import type { ReactNode } from 'react';
import { Alert } from '@mui/material';
import { useFeatureReleased } from './useRelease';

/**
 * Shows its children only while the feature switch `name` is on (RELEASE_FEATURES, set in the
 * release console). `page` shows the "not released" notice instead of nothing, for a feature
 * that is a page of its own.
 */
export function ReleasedFeature({
  name,
  page = false,
  children,
}: {
  name: string;
  page?: boolean;
  children: ReactNode;
}) {
  const featureOn = useFeatureReleased();
  if (featureOn(name)) return <>{children}</>;
  return page ? (
    <Alert severity="info" sx={{ maxWidth: 640 }}>
      This feature is not released yet. It will open in a later release.
    </Alert>
  ) : null;
}
